export default {
    "Features.index.589609-0": "探索功能",
    "Features.index.589609-1": "您可以使用此部分列出您的产品功能。",
    "Features.index.589609-2": "20 多个基于用例的应用页面",
    "Features.index.589609-3": "100 多个组件和小部件",
    "Features.index.589609-4": "实用图表库",
    "Features.index.589609-5": "符合 HTML5 + CSS3 标准",
    "Features.index.589609-6": "基于 Bootstrap 5 和 SCSS 构建",
    "Features.index.589609-7": "完全响应式",
    "Features.index.589609-8": "漂亮的界面",
    "Features.index.589609-9": "免费更新和支持"
}